/* eslint-disable @typescript-eslint/no-explicit-any */
import { App, createApp } from 'vue'
import GuideRemind from './GuideRemind.vue'

let vueInstance: App<Element> | null = null

export default {
  install(Vue: any) {
    const guideRemindFun = ({
      lists,
      skipCallBackFun,
      pageCompleteCallBackFun,
      isLastPage
    }: any) => {
      destroy()
      const parent = document.createElement('div')
      parent.id = 'guideRemindDom'
      const el = document.createElement('div')
      parent.appendChild(el)
      document.body.appendChild(parent)

      vueInstance = createApp(GuideRemind, {
        lists,
        skipCallBackFun,
        pageCompleteCallBackFun,
        isLastPage,
        destroyAppFun: destroy
      })
      vueInstance.mount(el)
      function destroy() {
        if (vueInstance) {
          vueInstance.unmount()
          vueInstance = null
        }
        removeDom()
      }
      function removeDom() {
        const getGuideRemindDom = document.querySelector('#guideRemindDom')
        if (getGuideRemindDom) {
          getGuideRemindDom.innerHTML = ''
          document.body.removeChild(getGuideRemindDom)
        }
      }
      return {
        vueInstance,
        destroy
      }
    }

    Vue.provide('guideRemindFun', guideRemindFun)
  }
}
